import React from 'react';
import { Box, Typography } from '@mui/material';

import aiGuideIcon from '../../../assets/images/ai_guide_3.png';
import aiGuideIconSmall from '../../../assets/images/ic_AI_1.png';

export interface RoleplayGuideCardProps {
  showGuide: boolean;
  guideText: string;
  isSmallScreen: boolean;
}

export const RoleplayGuideCard: React.FC<RoleplayGuideCardProps> = ({
  showGuide,
  guideText,
  isSmallScreen,
}) => {
  if (!showGuide) return null;

  const text = guideText || 'アドバイスはありません';

  if (isSmallScreen) {
    return (
      <Box sx={{ width: '100%' }}>
        <Box sx={{
          width: '100%',
          backgroundColor: '#2769B1',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          display: 'flex',
          gap: '18px',
          padding: '8px 10px',
          margin: '0 auto',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
        }}>
          <Box component="img" src={aiGuideIconSmall} alt="AIガイド" />
          <Typography sx={{
            color: '#fff',
            fontSize: '18px',
            fontWeight: 400,
            letterSpacing: '0.25em',
          }}>
            AIガイド
          </Typography>
        </Box>
        <Box sx={{
          width: '100%',
          backgroundColor: '#D6E8FF',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          display: 'flex',
          gap: '18px',
          padding: '15px 30px 0px 30px',
          margin: '0 auto',
          flexDirection: 'row',
        }}>
          <Box sx={{
            color: '#023B87',
            lineHeight: '1.5em',
            padding: 0,
            flex: 1,
            mb: 2,
          }}>
            <Typography sx={{ fontSize: '0.875rem' }}>{text}</Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{
      width: '100%',
      backgroundColor: '#D6E8FF',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '18px',
      padding: '15px 30px 0px 30px',
      margin: '0 auto',
      flexDirection: 'row',
    }}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        minWidth: '60px',
      }}>
        <Box
          component="img"
          src={aiGuideIcon}
          alt="AI"
          sx={{ width: '147px', bgcolor: '#D6E8FF' }}
        />
      </Box>
      <Box sx={{
        fontSize: '15px',
        color: '#023B87',
        lineHeight: 1.7,
        borderRadius: '8px',
        padding: 0,
        flex: 1,
        mb: 2,
      }}>
        <Typography>{text}</Typography>
      </Box>
    </Box>
  );
};
